import { render, staticRenderFns } from "./exhibitionDetails.vue?vue&type=template&id=07a853b1&scoped=true&"
import script from "./exhibitionDetails.vue?vue&type=script&lang=js&"
export * from "./exhibitionDetails.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionDetails.vue?vue&type=style&index=0&id=07a853b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a853b1",
  null
  
)

export default component.exports